var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-content",class:{
    'expanding': _vm.expanding,
    'chinese': _vm.language === 'zh-CN',
    'english': _vm.language !== 'zh-CN'
  }},[_c('page-header',{on:{"expand":_vm.expand}}),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{ref:"pageContent",staticClass:"page-content"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{ref:"pageContent",staticClass:"page-content"}):_vm._e(),_c('div',{staticClass:"footer-wrapper"},[_c('FootBar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }